import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import { CustomerFlow } from '../models';

export const useCustomerFlowStore = defineStore('CustomerFlow', () => {
  // State
  const customerFlows = ref<CustomerFlow[]>([CustomerFlow.Base]);

  // Getters
  const isFlightOnlyFromMarketplaceFlow = computed<boolean>(() =>
    customerFlows.value.includes(CustomerFlow.FlightOnlyFromMarketplace)
  );

  const isHotelOnlyFromMarketplaceFlow = computed<boolean>(() =>
    customerFlows.value.includes(CustomerFlow.HotelOnlyFromMarketplace)
  );

  const isInfiniteLoadReloadFlow = computed<boolean>(() =>
    customerFlows.value.includes(CustomerFlow.InfiniteLoadReload)
  );

  const isMetaHotelFlow = computed<boolean>(() =>
    customerFlows.value.includes(CustomerFlow.MetaHotel)
  );

  const isCarTripFlow = computed<boolean>(() =>
    customerFlows.value.includes(CustomerFlow.CarTrip)
  );

  const isHotelSelectionForCountryFromMarketplaceFlow = computed<boolean>(() =>
    customerFlows.value.includes(
      CustomerFlow.HotelSelectionForCountryFromMarketplace
    )
  );

  // Actions
  function setCustomerFlow(flow: CustomerFlow): void {
    customerFlows.value.push(flow);
  }

  function resetCustomerFlow(): void {
    customerFlows.value = [CustomerFlow.Base];
  }

  return {
    // Getters
    isFlightOnlyFromMarketplaceFlow,
    isHotelOnlyFromMarketplaceFlow,
    isHotelSelectionForCountryFromMarketplaceFlow,
    isInfiniteLoadReloadFlow,
    isMetaHotelFlow,
    isCarTripFlow,

    // Actions
    setCustomerFlow,
    resetCustomerFlow,
  };
});
